import { Routes } from '@angular/router';
import { AuthRouteEnum } from './auth-route-enum';

export default [
  {
    path: AuthRouteEnum.LOGIN,
    loadComponent: () => import('./pages/login/login'),
  },
  {
    path: AuthRouteEnum.REGISTER,
    loadComponent: () => import('./pages/register/register'),
  },
  {
    path: AuthRouteEnum.ONEID,
    loadComponent: () =>
      import('./pages/one-id-callback/one-id-callback.component'),
  },
  {
    path: AuthRouteEnum.FORGET_PASSWORD,
    loadComponent: () =>
      import('./pages/forget-password/forget-password.component'),
  },
] as Routes;
